import { render } from "./TabsStudio.vue?vue&type=template&id=56da6171&scoped=true"
import script from "./TabsStudio.vue?vue&type=script&lang=js"
export * from "./TabsStudio.vue?vue&type=script&lang=js"

import "./TabsStudio.vue?vue&type=style&index=0&id=56da6171&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56da6171"]])

export default __exports__